<template>
    <div class="main-body">
        <div class="header">
            订单评价
        </div>
        <div class="out">
<!--            <div class="search2">-->
<!--               -->
<!--                <div style="clear: both;"></div>-->
<!--            </div>-->


            <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column prop="user.name" label="评价人" width="100"></el-table-column>
                <el-table-column prop="user.phone" label="手机号" width="120"></el-table-column>
                <!-- <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="300"></el-table-column> -->

                <el-table-column prop="createTime" :formatter="timefilter" width="200" label="评价时间"></el-table-column>
                <el-table-column prop="orderBusiness.price" label="订单价格" width="150"></el-table-column>
                <!-- <el-table-column
                        prop="orderBusiness.isSchedule"
                        :formatter="isSchedules"
                        label="预订单">
                </el-table-column> -->
                <el-table-column
                        prop="orderBusiness.orderType"
                        :formatter="statusTitle"
                        label="订单类型" width="150">
                </el-table-column>
                <el-table-column
                        prop="orderBusiness.status"
                        :formatter="statuss"
                        label="订单状态"
                        width="150">
                </el-table-column>
                <el-table-column prop="remarks" label="评价内容" ></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
                    </template>
                </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <AppraiseInfo ref="myAppraiseInfo" v-show="showModalAppraiseInfo" v-bind:goodsClassValue="goodsClassValue" v-on:closeAppraiseInfo="closeAppraiseInfo" v-on:getList="getList"></AppraiseInfo>
        <!-- <Edit ref="myEdit" v-show="showModalEdit" v-bind:goodsClassValue="goodsClassValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    import AppraiseInfo from "./AppraiseInfo";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,
                showModalAppraiseInfo:false,
                tableData:null,
                goodsClassCode:'',
                name:null,
                businessCode:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                goodsClassValue:[],

            }
        },
        components:{
            AppraiseInfo
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight+50;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){

                this.th = val+50;
            },
        },
        methods:{
            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            handleInfo:function(index,row){
                this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
                this.$refs.myAppraiseInfo.init(row);
            },
            closeAppraiseInfo:function(){
                this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableLoading=true
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusinessAppraise/BusinessPageList",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        // businessCode:this.businessCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    _this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }



        }
    }
</script>

<style scoped>

</style>
